"use strict";

exports.__esModule = true;
exports.DeviceDataTableFields = DeviceDataTableFields;
var _react = _interopRequireDefault(require("react"));
var _Fields = require("../AdvancedDataTable/Fields");
var _Fields2 = require("../DataTable/Fields");
var _DataSources = require("../DataTable/DataSources");
var _Core = require("../../Core");
var _DataTable = require("../DataTable");
var _DataTableColumn = require("../DataTableColumn");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DeviceDataTableElement.
 */
function DeviceDataTableFields(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var deviceDataDefinition = _DataSources.DataSourceDefinitions["deviceData"](translate);
  var renderChildren = function renderChildren(data) {
    var configuration = element.props.configuration;
    if (!configuration && deviceDataDefinition) {
      configuration = (0, _DataTable.boostrapDefaultColumns)(configuration, elementEditor, deviceDataDefinition, path);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "DeviceDataTableFields"
    }, /*#__PURE__*/_react["default"].createElement(_Fields2.AddColumnField, {
      "data-testid": "DeviceDataTableFields.AddColumnField",
      key: "DeviceDataTableFields.AddColumnField",
      dataSourceDefinition: deviceDataDefinition,
      onAddColumn: function onAddColumn(column) {
        elementEditor.appendElementAt(path, _DataTableColumn.DataTableColumnWidget.createElement(Object.assign({}, column)));
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
      key: "DeviceDataTableFields.DataRangeSelector",
      value: element.props.dataRange,
      setProp: function setProp(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.dataRange !== val) {
            el.props.dataRange = val;
          }
        });
      },
      fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
      setFetchOnlyOnSelection: function setFetchOnlyOnSelection(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.fetchDataOnlyOnSelection !== val) {
            el.props.fetchDataOnlyOnSelection = val;
          }
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields2.PaginationField, {
      key: "DeviceDataTableFields.PaginationField",
      defaultPageSize: configuration ? configuration.defaultPageSize : "auto",
      setDefaultPageSize: function setDefaultPageSize(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          defaultPageSize: val
        }));
      },
      enablePagination: configuration ? configuration.enablePagination : true,
      setPagination: function setPagination(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          enablePagination: val
        }));
      }
    }));
  };
  return renderChildren({});
}